import { createSelector } from 'reselect'
import getCurTierNameLoyaltySelect from 'modules/loyalty/redux/selectors/get-cur-tier-name'
import isEligibleToTemporaryUnlockedSamplesSelect from 'modules/temporary-unlocked-samples/redux/selectors/is-eligible-to-temporary-unlocked-samples'
import hasReachedGoldSamplesLimitTemporaryUnlockedSamplesSelect from 'modules/temporary-unlocked-samples/redux/selectors/has-reached-gold-samples-limit'
import hasReachedDiamondSamplesLimitTemporaryUnlockedSamplesSelect from 'modules/temporary-unlocked-samples/redux/selectors/has-reached-diamond-samples-limit'
import isUnlockedProductVariantSelectorUtil from 'modules/product/redux/selectors/is-unlocked/utils'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'

export default function isUnlockedProductVariantSelector ({
  productVariant
}) {
  return createSelector(
    getCurTierNameLoyaltySelect,
    isEligibleToTemporaryUnlockedSamplesSelect,
    hasReachedGoldSamplesLimitTemporaryUnlockedSamplesSelect,
    hasReachedDiamondSamplesLimitTemporaryUnlockedSamplesSelect,
    (
      loyaltyTierName,
      isEligibleToTemporaryUnlockedSamples,
      hasReachedGoldSamplesLimitTemporaryUnlockedSamples,
      hasReachedDiamondSamplesLimitTemporaryUnlockedSamples
    ) => (
      isUnlockedProductVariantSelectorUtil({
        productVariant,
        loyaltyTierName,
        isEligibleToTemporaryUnlockedSamples,
        hasReachedGoldSamplesLimitTemporaryUnlockedSamples,
        hasReachedDiamondSamplesLimitTemporaryUnlockedSamples,
        isSelfGifting: isSelfGiftingUrlLocationUtil()
      })
    )
  )
}
